import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';

export default class UserNotificationUIListener extends UIListener {

    constructor() {
        super();
    }

    public onPropertyValueUpdated(context: DetailViewContext, property: string): void {
        if (property === 'NotificationType.Value') {
            this.updateGui(context);
        }
    };

    public onDetailViewReady(context: DetailViewContext) {
        this.updateGui(context);
    }

    public onSummaryViewReady(context: DetailViewContext) {
        this.updateGui(context);
    }

    private updateGui(context: DetailViewContext): void {
        let factory = context.getUIFactory<ControlFactory>('CustomUsers');
        let value = context.genericObject.getValue('NotificationType.Value');
        factory?.isVisible(value === 'Custom');
    }
}

ComponentManager.setUIListener('UserNotificationUIListener', UserNotificationUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.UserNotificationUIListener', UserNotificationUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');